import { useEffect, useState } from 'react';
import { DEVICE_ID_STORAGE_KEY } from '@ax/constants';

const useDeviceId = () => {
  const [deviceId, setDeviceId] = useState<string | null>(null);

  useEffect(() => {
    const deviceId = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
    if (deviceId) {
      setDeviceId(deviceId);
    } else {
      const newDeviceId = `${Math.random().toString(36).substring(2)}${Math.random()
        .toString(36)
        .substring(2)}`;
      localStorage.setItem(DEVICE_ID_STORAGE_KEY, newDeviceId);
      setDeviceId(newDeviceId);
    }
  }, []);

  return { deviceId };
};

export default useDeviceId;
